import React from 'react';
import { useAuth } from '../App';
import { useNavigate } from 'react-router-dom';

const SubscriptionStatusCard = ({ showManageButton = true }) => {
    const { userProfile } = useAuth();
    const navigate = useNavigate();

    const { membershipType, subscriptionStatus, currentPeriodEnd } = userProfile || {};

    const isPremium = membershipType === 'premium';
    const isActive = subscriptionStatus === 'active';

    const formatDate = (timestamp) => {
        if (!timestamp) return 'N/A';
        return new Date(timestamp.seconds * 1000).toLocaleDateString();
    };

    return (
        <div className="border rounded-lg p-6 bg-white shadow-sm">
            <h3 className="text-lg font-semibold mb-4">Subscription Status</h3>
            
            {!isPremium ? (
                <div>
                    <p className="text-gray-600 mb-4">You are currently on the <span className="font-bold">Free</span> plan.</p>
                    {showManageButton && (
                        <button
                            onClick={() => navigate('/premium-upgrade')}
                            className="bg-blue-600 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
                        >
                            Upgrade to Premium
                        </button>
                    )}
                </div>
            ) : (
                <div>
                    <div className="flex items-center mb-2">
                        <span className="font-bold text-green-600">Premium Member</span>
                        {isActive && (
                            <span className="ml-2 px-2 py-1 text-xs font-semibold text-green-800 bg-green-100 rounded-full">Active</span>
                        )}
                    </div>
                    <p className="text-sm text-gray-500">
                        Next billing date: {formatDate(currentPeriodEnd)}
                    </p>
                    {/* Placeholder for future "Manage Subscription" button */}
                    {showManageButton && (
                        <button className="mt-4 text-sm text-blue-600 hover:underline">
                            Manage Subscription
                        </button>
                    )}
                </div>
            )}
        </div>
    );
};

export default SubscriptionStatusCard;